import { useWelcomeQuery } from '../api/getWelcomeDetails';

const useGetCustKey = (): string => {
  const { data } = useWelcomeQuery();

  return data?.userInfo?.custKey ?? '';
};

export default useGetCustKey;
